import * as THREE from 'three';
import { DebugVisualizer } from '../scene/objects/debugVisualizer.js';

export class KeypointsManagerPose {
  constructor(videoCanvas, videoInsert, width, height, scene) {
    this.scene = scene; // Référence vers la scène Three.js

    // Initialiser le debug visualizer si une scène est fournie
    if (this.scene) {
     // this.debugVisualizer = new DebugVisualizer(this.scene);
    }

    this.poseVisible = false;
    this.poseLandmarks2d = [];
    this.poseLandmarks3d = [];
    this.adjustedposeLandmarks2d = [];
    this.adjustedposeLandmarks3d = [];
    this.threeposeLandmarks2d = [];
    this.threeposeLandmarks3d = [];


  }
  detectedPoseUpdate(results, settings, width, height) {
    this.poseVisible = results?.landmarks?.length > 0;

    if (this.poseVisible) {
      this.poseLandmarks2d = results.landmarks[0]; // Assuming one pose
      this.poseLandmarks3d = results.worldLandmarks?.[0] || []; // Avoid undefined


      // Conserver les landmarks originaux pour d'autres usages si nécessaire
      this.originalLandmarks = results.landmarks[0]; // Landmarks originaux
      this.originalWorldLandmarks = results.worldLandmarks?.[0] || []; // Landmarks 3D originaux

      // Adapter les coordonnées à la résolution réduite
      this.adjustedposeLandmarks2d = this.poseLandmarks2d.map(point => ({
        x: (-0.5 + point.x) * width,
        y: (0.5 - point.y) * height,
        z: -point.z * (width/5)
      }));

      this.adjustedposeLandmarks3d = this.poseLandmarks3d.map(point => ({
        x: -0.5 + point.x,
        y: 0.5 - point.y,
        z: -point.z
      }));


      this.threeposeLandmarks2d = this.adjustedposeLandmarks2d.map(point => new THREE.Vector3(point.x, point.y, point.z));
      this.threeposeLandmarks3d = this.adjustedposeLandmarks3d.map(point => new THREE.Vector3(point.x, point.y, point.z));



      this.positionsPose2d = {
        nose: this.threeposeLandmarks2d[0],
        left_eye_inner: this.threeposeLandmarks2d[1],
        left_eye: this.threeposeLandmarks2d[2],
        left_eye_outer: this.threeposeLandmarks2d[3],
        right_eye_inner: this.threeposeLandmarks2d[4],
        right_eye: this.threeposeLandmarks2d[5],
        right_eye_outer: this.threeposeLandmarks2d[6],
        left_ear: this.threeposeLandmarks2d[7],
        right_ear: this.threeposeLandmarks2d[8],
        left_mouth: this.threeposeLandmarks2d[9],
        right_mouth: this.threeposeLandmarks2d[10],
        left_shoulder: this.threeposeLandmarks2d[11],
        right_shoulder: this.threeposeLandmarks2d[12],
        left_elbow: this.threeposeLandmarks2d[13],
        right_elbow: this.threeposeLandmarks2d[14],
        left_wrist: this.threeposeLandmarks2d[15],
        right_wrist: this.threeposeLandmarks2d[16],
        left_pinky: this.threeposeLandmarks2d[17],
        right_pinky: this.threeposeLandmarks2d[18],
        left_index: this.threeposeLandmarks2d[19],
        right_index: this.threeposeLandmarks2d[20],
        left_thumb: this.threeposeLandmarks2d[21],
        right_thumb: this.threeposeLandmarks2d[22],
        left_hip: this.threeposeLandmarks2d[23],
        right_hip: this.threeposeLandmarks2d[24],
        left_knee: this.threeposeLandmarks2d[25],
        right_knee: this.threeposeLandmarks2d[26],
        left_ankle: this.threeposeLandmarks2d[27],
        right_ankle: this.threeposeLandmarks2d[28],
        left_heel: this.threeposeLandmarks2d[29],
        right_heel: this.threeposeLandmarks2d[30],
        left_foot_index: this.threeposeLandmarks2d[31],
        right_foot_index: this.threeposeLandmarks2d[32],
        center_hips: null,
        center_mouth: null,
        center_shoulders: null,
        center_ears: null,
        center_eyes: null,
        right_torso: null,
        left_torso: null,
        center_torso: null,
        left_arm: null,
        right_arm: null,
        left_forearm: null,
        right_forearm: null,
        left_hand: null,
        right_hand: null,
        neck: null
      };


      
      this.positionsPose2d.center_hips = avg(this.positionsPose2d.left_hip, this.positionsPose2d.right_hip);
      this.positionsPose2d.center_shoulders = avg(this.positionsPose2d.left_shoulder, this.positionsPose2d.right_shoulder);
      this.positionsPose2d.center_ears = avg(this.positionsPose2d.left_ear, this.positionsPose2d.right_ear);
      this.positionsPose2d.center_eyes = avg(this.positionsPose2d.left_eye, this.positionsPose2d.right_eye);
      this.positionsPose2d.right_torso = avg(this.positionsPose2d.right_shoulder, this.positionsPose2d.right_hip);
      this.positionsPose2d.left_torso = avg(this.positionsPose2d.left_shoulder, this.positionsPose2d.left_hip);
      this.positionsPose2d.center_torso = avg(this.positionsPose2d.center_hips, this.positionsPose2d.center_shoulders);
      this.positionsPose2d.center_mouth = avg(this.positionsPose2d.left_mouth, this.positionsPose2d.right_mouth);
      this.positionsPose2d.left_arm = avg(this.positionsPose2d.left_shoulder, this.positionsPose2d.left_elbow);
      this.positionsPose2d.right_arm = avg(this.positionsPose2d.right_shoulder, this.positionsPose2d.right_elbow);
      this.positionsPose2d.left_forearm = avg(this.positionsPose2d.left_elbow, this.positionsPose2d.left_wrist);
      this.positionsPose2d.right_forearm = avg(this.positionsPose2d.right_elbow, this.positionsPose2d.right_wrist);
      this.positionsPose2d.left_hand = avg3(this.positionsPose2d.left_pinky, this.positionsPose2d.left_thumb, this.positionsPose2d.left_wrist);
      this.positionsPose2d.right_hand = avg3(this.positionsPose2d.right_pinky, this.positionsPose2d.right_thumb, this.positionsPose2d.right_wrist);


      // Ajout des positions intermédiaires pour les jambes
      this.positionsPose2d.left_upleg = avg(this.positionsPose2d.left_hip, this.positionsPose2d.left_knee);
      this.positionsPose2d.right_upleg = avg(this.positionsPose2d.right_hip, this.positionsPose2d.right_knee);
      this.positionsPose2d.left_leg = avg(this.positionsPose2d.left_knee, this.positionsPose2d.left_ankle);
      this.positionsPose2d.right_leg = avg(this.positionsPose2d.right_knee, this.positionsPose2d.right_ankle);
      this.positionsPose2d.left_foot = avg(this.positionsPose2d.left_ankle, this.positionsPose2d.left_foot_index);
      this.positionsPose2d.right_foot = avg(this.positionsPose2d.right_ankle, this.positionsPose2d.right_foot_index);

      // Ajout du point nuque (entre les épaules et les oreilles)
      this.positionsPose2d.neck = avg(this.positionsPose2d.center_shoulders, this.positionsPose2d.center_ears);

      // Créer le tableau de visibilité basé sur la valeur Z des landmarks2d
      this.visibilityPose = {
        nose: this.poseLandmarks2d[0]?.visibility || 0,
        left_eye_inner: this.poseLandmarks2d[1]?.visibility || 0,
        left_eye: this.poseLandmarks2d[2]?.visibility || 0,
        left_eye_outer: this.poseLandmarks2d[3]?.visibility || 0,
        right_eye_inner: this.poseLandmarks2d[4]?.visibility || 0,
        right_eye: this.poseLandmarks2d[5]?.visibility || 0,
        right_eye_outer: this.poseLandmarks2d[6]?.visibility || 0,
        left_ear: this.poseLandmarks2d[7]?.visibility || 0,
        right_ear: this.poseLandmarks2d[8]?.visibility || 0,
        left_mouth: this.poseLandmarks2d[9]?.visibility || 0,
        right_mouth: this.poseLandmarks2d[10]?.visibility || 0,
        left_shoulder: this.poseLandmarks2d[11]?.visibility || 0,
        right_shoulder: this.poseLandmarks2d[12]?.visibility || 0,
        left_elbow: this.poseLandmarks2d[13]?.visibility || 0,
        right_elbow: this.poseLandmarks2d[14]?.visibility || 0,
        left_wrist: this.poseLandmarks2d[15]?.visibility || 0,
        right_wrist: this.poseLandmarks2d[16]?.visibility || 0,
        left_pinky: this.poseLandmarks2d[17]?.visibility || 0,
        right_pinky: this.poseLandmarks2d[18]?.visibility || 0,
        left_index: this.poseLandmarks2d[19]?.visibility || 0,
        right_index: this.poseLandmarks2d[20]?.visibility || 0,
        left_thumb: this.poseLandmarks2d[21]?.visibility || 0,
        right_thumb: this.poseLandmarks2d[22]?.visibility || 0,
        left_hip: this.poseLandmarks2d[23]?.visibility || 0,
        right_hip: this.poseLandmarks2d[24]?.visibility || 0,
        left_knee: this.poseLandmarks2d[25]?.visibility || 0,
        right_knee: this.poseLandmarks2d[26]?.visibility || 0,
        left_ankle: this.poseLandmarks2d[27]?.visibility || 0,
        right_ankle: this.poseLandmarks2d[28]?.visibility || 0,
        left_heel: this.poseLandmarks2d[29]?.visibility || 0,
        right_heel: this.poseLandmarks2d[30]?.visibility || 0,
        left_foot_index: this.poseLandmarks2d[31]?.visibility || 0,
        right_foot_index: this.poseLandmarks2d[32]?.visibility || 0,
        // Points calculés - utiliser la moyenne des visibilités des points composants
        center_hips: Math.min(this.poseLandmarks2d[23]?.visibility || 0, this.poseLandmarks2d[24]?.visibility || 0),
        center_mouth: Math.min(this.poseLandmarks2d[9]?.visibility || 0, this.poseLandmarks2d[10]?.visibility || 0),
        center_shoulders: Math.min(this.poseLandmarks2d[11]?.visibility || 0, this.poseLandmarks2d[12]?.visibility || 0),
        center_ears: Math.min(this.poseLandmarks2d[7]?.visibility || 0, this.poseLandmarks2d[8]?.visibility || 0),
        center_eyes: Math.min(this.poseLandmarks2d[2]?.visibility || 0, this.poseLandmarks2d[5]?.visibility || 0),
        right_torso: Math.min(this.poseLandmarks2d[12]?.visibility || 0, this.poseLandmarks2d[24]?.visibility || 0),
        left_torso: Math.min(this.poseLandmarks2d[11]?.visibility || 0, this.poseLandmarks2d[23]?.visibility || 0),
        center_torso: Math.min(this.poseLandmarks2d[11]?.visibility || 0, this.poseLandmarks2d[12]?.visibility || 0, this.poseLandmarks2d[23]?.visibility || 0, this.poseLandmarks2d[24]?.visibility || 0),
        left_arm: Math.min(this.poseLandmarks2d[11]?.visibility || 0, this.poseLandmarks2d[13]?.visibility || 0),
        right_arm: Math.min(this.poseLandmarks2d[12]?.visibility || 0, this.poseLandmarks2d[14]?.visibility || 0),
        left_forearm: Math.min(this.poseLandmarks2d[13]?.visibility || 0, this.poseLandmarks2d[15]?.visibility || 0),
        right_forearm: Math.min(this.poseLandmarks2d[14]?.visibility || 0, this.poseLandmarks2d[16]?.visibility || 0),
        left_hand: Math.min(this.poseLandmarks2d[17]?.visibility || 0, this.poseLandmarks2d[21]?.visibility || 0, this.poseLandmarks2d[15]?.visibility || 0),
        right_hand: Math.min(this.poseLandmarks2d[18]?.visibility || 0, this.poseLandmarks2d[22]?.visibility || 0, this.poseLandmarks2d[16]?.visibility || 0),
        left_upleg: Math.min(this.poseLandmarks2d[23]?.visibility || 0, this.poseLandmarks2d[25]?.visibility || 0),
        right_upleg: Math.min(this.poseLandmarks2d[24]?.visibility || 0, this.poseLandmarks2d[26]?.visibility || 0),
        left_leg: Math.min(this.poseLandmarks2d[25]?.visibility || 0, this.poseLandmarks2d[27]?.visibility || 0),
        right_leg: Math.min(this.poseLandmarks2d[26]?.visibility || 0, this.poseLandmarks2d[28]?.visibility || 0),
        left_foot: Math.min(this.poseLandmarks2d[27]?.visibility || 0, this.poseLandmarks2d[31]?.visibility || 0),
        right_foot: Math.min(this.poseLandmarks2d[28]?.visibility || 0, this.poseLandmarks2d[32]?.visibility || 0),
        neck: Math.min(this.poseLandmarks2d[11]?.visibility || 0, this.poseLandmarks2d[12]?.visibility || 0, this.poseLandmarks2d[7]?.visibility || 0, this.poseLandmarks2d[8]?.visibility || 0)
      };

 
      this.positionsPose3d = {
        nose: this.threeposeLandmarks3d[0],
        left_eye_inner: this.threeposeLandmarks3d[1],
        left_eye: this.threeposeLandmarks3d[2],
        left_eye_outer: this.threeposeLandmarks3d[3],
        right_eye_inner: this.threeposeLandmarks3d[4],
        right_eye: this.threeposeLandmarks3d[5],
        right_eye_outer: this.threeposeLandmarks3d[6],
        left_ear: this.threeposeLandmarks3d[7],
        right_ear: this.threeposeLandmarks3d[8],
        left_mouth: this.threeposeLandmarks3d[9],
        right_mouth: this.threeposeLandmarks3d[10],
        left_shoulder: this.threeposeLandmarks3d[11],
        right_shoulder: this.threeposeLandmarks3d[12],
        left_elbow: this.threeposeLandmarks3d[13],
        right_elbow: this.threeposeLandmarks3d[14],
        left_wrist: this.threeposeLandmarks3d[15],
        right_wrist: this.threeposeLandmarks3d[16],
        left_pinky: this.threeposeLandmarks3d[17],
        right_pinky: this.threeposeLandmarks3d[18],
        left_index: this.threeposeLandmarks3d[19],
        right_index: this.threeposeLandmarks3d[20],
        left_thumb: this.threeposeLandmarks3d[21],
        right_thumb: this.threeposeLandmarks3d[22],
        left_hip: this.threeposeLandmarks3d[23],
        right_hip: this.threeposeLandmarks3d[24],
        left_knee: this.threeposeLandmarks3d[25],
        right_knee: this.threeposeLandmarks3d[26],
        left_ankle: this.threeposeLandmarks3d[27],
        right_ankle: this.threeposeLandmarks3d[28],
        left_heel: this.threeposeLandmarks3d[29],
        right_heel: this.threeposeLandmarks3d[30], 
        left_foot_index: this.threeposeLandmarks3d[31],
        right_foot_index: this.threeposeLandmarks3d[32],
        center_hips: null,
        center_mouth: null,
        center_shoulders: null,
        center_ears: null,
        center_eyes: null,
        right_torso: null,
        left_torso: null,
        center_torso: null,
        left_arm: null,
        right_arm: null,
        left_forearm: null,
        right_forearm: null,
        left_hand: null,
        right_hand: null,
        neck: null

      };

      this.positionsPose3d.center_hips = avg(this.positionsPose3d.left_hip, this.positionsPose3d.right_hip);
      this.positionsPose3d.center_shoulders = avg(this.positionsPose3d.left_shoulder, this.positionsPose3d.right_shoulder);
      this.positionsPose3d.center_ears = avg(this.positionsPose3d.left_ear, this.positionsPose3d.right_ear);
      this.positionsPose3d.center_eyes = avg(this.positionsPose3d.left_eye_outer, this.positionsPose3d.right_eye_outer);
      this.positionsPose3d.right_torso = avg(this.positionsPose3d.right_shoulder, this.positionsPose3d.right_hip);
      this.positionsPose3d.left_torso = avg(this.positionsPose3d.left_shoulder, this.positionsPose3d.left_hip);
      this.positionsPose3d.center_torso = avg(this.positionsPose3d.center_hips, this.positionsPose3d.center_shoulders);
      this.positionsPose3d.center_mouth = avg(this.positionsPose3d.left_mouth, this.positionsPose3d.right_mouth);
      this.positionsPose3d.left_arm = avg(this.positionsPose3d.left_shoulder, this.positionsPose3d.left_elbow);
      this.positionsPose3d.right_arm = avg(this.positionsPose3d.right_shoulder, this.positionsPose3d.right_elbow);
      this.positionsPose3d.left_forearm = avg(this.positionsPose3d.left_elbow, this.positionsPose3d.left_wrist);
      this.positionsPose3d.right_forearm = avg(this.positionsPose3d.right_elbow, this.positionsPose3d.right_wrist);
      this.positionsPose3d.left_hand = avg3(this.positionsPose3d.left_pinky, this.positionsPose3d.left_thumb, this.positionsPose3d.left_wrist);
      this.positionsPose3d.right_hand = avg3(this.positionsPose3d.right_pinky, this.positionsPose3d.right_thumb, this.positionsPose3d.right_wrist);
   // Ajout des positions intermédiaires pour les jambes (3D)
      this.positionsPose3d.left_upleg = avg(this.positionsPose3d.left_hip, this.positionsPose3d.left_knee);
      this.positionsPose3d.right_upleg = avg(this.positionsPose3d.right_hip, this.positionsPose3d.right_knee);
      this.positionsPose3d.left_leg = avg(this.positionsPose3d.left_knee, this.positionsPose3d.left_ankle);
      this.positionsPose3d.right_leg = avg(this.positionsPose3d.right_knee, this.positionsPose3d.right_ankle);
      this.positionsPose3d.left_foot = avg(this.positionsPose3d.left_ankle, this.positionsPose3d.left_foot_index);
      this.positionsPose3d.right_foot = avg(this.positionsPose3d.right_ankle, this.positionsPose3d.right_foot_index);

      // Ajout du point nuque (entre les épaules et les oreilles) (3D)
      this.positionsPose3d.neck = avg(this.positionsPose3d.center_shoulders, this.positionsPose3d.center_ears);

      //console.log("Positions 3D:", this.positionsPose2d.center_torso);

      //CALCUL ROTATION TORSO
      const torsoUpVector = new THREE.Vector3().subVectors(this.positionsPose3d.center_shoulders, this.positionsPose3d.center_hips).normalize();
      const torsoRightVector = new THREE.Vector3().subVectors(this.positionsPose3d.left_torso, this.positionsPose3d.right_torso).normalize();
      const torsoForwardVector = new THREE.Vector3().crossVectors(torsoRightVector, torsoUpVector).normalize();

      const rotationTorsoMatrix = new THREE.Matrix4();
      rotationTorsoMatrix.makeBasis(torsoRightVector, torsoUpVector, torsoForwardVector);
      const torsoQuaternion = new THREE.Quaternion();
      torsoQuaternion.setFromRotationMatrix(rotationTorsoMatrix);

      const neutralRotation = new THREE.Quaternion(); // Rotation neutre pour le modèle de pose

      const offsetQuaternion = new THREE.Quaternion();
      offsetQuaternion.setFromAxisAngle(new THREE.Vector3(0, 0, 1), 180 * Math.PI / 180); // Ajustement de 180 degrés en radians
      //Methode 1
      const headRightAxis = new THREE.Vector3().subVectors(this.positionsPose3d.right_ear, this.positionsPose3d.left_ear).normalize();
      const headForwardAxis = new THREE.Vector3().subVectors(this.positionsPose3d.center_eyes, this.positionsPose3d.center_ears).normalize();
      const headUpAxis = new THREE.Vector3().crossVectors(headForwardAxis, headRightAxis).normalize();
      const rotationHeadMatrix = new THREE.Matrix4();
      rotationHeadMatrix.makeBasis(headRightAxis, headUpAxis, headForwardAxis);      
      const headQuaternion = new THREE.Quaternion();
      headQuaternion.setFromRotationMatrix(rotationHeadMatrix);      
      headQuaternion.multiply(offsetQuaternion);


       //Methode 2
      const headUpAxis2 = new THREE.Vector3().subVectors(this.positionsPose3d.center_eyes, this.positionsPose3d.center_mouth).normalize();
      const headRightAxis2 = new THREE.Vector3().subVectors(this.positionsPose3d.center_eyes, this.positionsPose3d.right_eye_outer).normalize();
      const headForwardAxis2 = new THREE.Vector3().crossVectors(headRightAxis2, headUpAxis2).normalize();
      const rotationHeadMatrix2 = new THREE.Matrix4();
      rotationHeadMatrix2.makeBasis(headRightAxis2, headUpAxis2, headForwardAxis2);      
      const headQuaternion2 = new THREE.Quaternion();
      headQuaternion2.setFromRotationMatrix(rotationHeadMatrix2);

      //Methode 3
      const headUpVector3 = new THREE.Vector3().subVectors(this.positionsPose3d.center_eyes, this.positionsPose3d.center_mouth).normalize();
      const headSideVector3 = new THREE.Vector3().subVectors(this.positionsPose3d.right_eye_outer, this.positionsPose3d.left_eye_outer).normalize();
      const headRotationEuler3 = new THREE.Vector3();
      headRotationEuler3.x = Math.PI / 2 - new THREE.Vector3(0, 0, 1).angleTo(headUpVector3.clone().projectOnPlane(new THREE.Vector3(1, 0, 0)));
      headRotationEuler3.y = Math.PI / 2 - new THREE.Vector3(headSideVector3.x, 0, headSideVector3.z).angleTo(new THREE.Vector3(0, 0, 1));
      headRotationEuler3.z = new THREE.Vector3(1, 0, 0).angleTo(headUpVector3.clone().projectOnPlane(new THREE.Vector3(0, 0, 1))) - Math.PI / 2;
      const headQuaternion3 = new THREE.Quaternion();
      headQuaternion3.setFromEuler(new THREE.Euler(headRotationEuler3.x, headRotationEuler3.y, headRotationEuler3.z, 'XYZ'));

       //Methode 4
      const headUpVector4 = new THREE.Vector3().crossVectors(headForwardAxis, headRightAxis).normalize();
      const headSideVector4 = headRightAxis.clone();
      const headRotationEuler4 = new THREE.Vector3();
      headRotationEuler4.x = new THREE.Vector3(0, 0, 1).angleTo(headUpVector4.clone().projectOnPlane(new THREE.Vector3(1, 0, 0))) - Math.PI / 2;
      headRotationEuler4.y = Math.PI / 2 - new THREE.Vector3(headSideVector4.x, 0, headSideVector4.z).angleTo(new THREE.Vector3(0, 0, 1));
      headRotationEuler4.z = - Math.PI / 2 - new THREE.Vector3(1, 0, 0).angleTo(headUpVector4.clone().projectOnPlane(new THREE.Vector3(0, 0, 1)));
      const headQuaternion4 = new THREE.Quaternion();
      headQuaternion4.setFromEuler(new THREE.Euler(headRotationEuler4.x, headRotationEuler4.y, headRotationEuler4.z, 'XYZ'));
      headQuaternion4.multiply(offsetQuaternion);

      // ============================================
      // Methode 5 - ROTATION TÊTE OPTIMISÉE
      // Utilise une approche géométrique précise basée sur le plan du visage
      // ============================================
      
      // Points clés du visage
      const nose = this.positionsPose3d.nose;
      const leftEye = this.positionsPose3d.left_eye;
      const rightEye = this.positionsPose3d.right_eye;
      const leftEar = this.positionsPose3d.left_ear;
      const rightEar = this.positionsPose3d.right_ear;
      const leftMouth = this.positionsPose3d.left_mouth;
      const rightMouth = this.positionsPose3d.right_mouth;
      
      // Centre des yeux (point pivot haut du visage)
      const eyeCenter = new THREE.Vector3().addVectors(leftEye, rightEye).multiplyScalar(0.5);
      // Centre de la bouche (point pivot bas du visage)
      const mouthCenter = new THREE.Vector3().addVectors(leftMouth, rightMouth).multiplyScalar(0.5);
      // Centre des oreilles (arrière de la tête)
      const earCenter = new THREE.Vector3().addVectors(leftEar, rightEar).multiplyScalar(0.5);
      
      // === CALCUL DES AXES DE LA TÊTE ===
      
      // 1. Axe X (droite-gauche) - basé sur la ligne inter-oculaire
      //    Plus fiable que les oreilles car les yeux sont mieux trackés de face
      const headRight5 = new THREE.Vector3().subVectors(rightEye, leftEye).normalize();
      
      // 2. Direction nez - utilisée pour déterminer où regarde la tête
      //    Le nez pointe vers l'avant du visage
      const noseDirection = new THREE.Vector3().subVectors(nose, earCenter).normalize();
      
      // 3. Axe Y (haut) - perpendiculaire à l'axe X et à la direction du nez
      //    On utilise aussi l'info verticale du visage (yeux -> bouche)
      const faceVertical = new THREE.Vector3().subVectors(eyeCenter, mouthCenter).normalize();
      
      // Calculer l'axe Up en combinant l'info du visage
      // On projette le vecteur vertical du visage pour qu'il soit perpendiculaire à l'axe X
      const headUp5 = new THREE.Vector3().copy(faceVertical);
      // Orthogonaliser par rapport à headRight5
      headUp5.sub(headRight5.clone().multiplyScalar(headUp5.dot(headRight5))).normalize();
      
      // 4. Axe Z (avant) - produit vectoriel des deux autres axes
      const headForward5 = new THREE.Vector3().crossVectors(headRight5, headUp5).normalize();
      
      // Ré-orthogonaliser l'axe Up pour avoir une base parfaitement orthonormée
      const headUp5Final = new THREE.Vector3().crossVectors(headForward5, headRight5).normalize();
      
      // Créer la matrice de rotation à partir de ces axes
      const headMatrix5 = new THREE.Matrix4();
      headMatrix5.makeBasis(headRight5, headUp5Final, headForward5);
      
      // Convertir en quaternion
      const headQuaternion5 = new THREE.Quaternion();
      headQuaternion5.setFromRotationMatrix(headMatrix5);
      
      // Appliquer l'offset de 180° sur Z pour corriger l'orientation
      headQuaternion5.multiply(offsetQuaternion);
      
      // Offset de rotation sur l'axe X (pitch) - ajuster cette valeur selon les besoins
      const headPitchOffset = Math.PI * 0.85; // ~18 degrés vers le bas, ajuster si nécessaire
      const headPitchOffsetQuat = new THREE.Quaternion();
      headPitchOffsetQuat.setFromAxisAngle(new THREE.Vector3(1, 0, 0), headPitchOffset);
      headQuaternion5.multiply(headPitchOffsetQuat);

      // --- Rotation bras gauche ---  
      const upperArmVec = new THREE.Vector3().subVectors( this.positionsPose3d.left_shoulder,this.positionsPose3d.left_elbow).normalize();
      const forearmVec = new THREE.Vector3().subVectors( this.positionsPose3d.left_elbow,this.positionsPose3d.left_wrist).normalize();     
      const leftArmXAxis = new THREE.Vector3().crossVectors(upperArmVec, forearmVec).normalize();
      const leftArmZAxis = new THREE.Vector3().crossVectors(leftArmXAxis, upperArmVec).normalize();   
      const leftArmMatrix = new THREE.Matrix4();
      leftArmMatrix.makeBasis(leftArmXAxis, upperArmVec, leftArmZAxis);
      const leftUpperArmRotation = new THREE.Quaternion().setFromRotationMatrix(leftArmMatrix);
      leftUpperArmRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1,0), Math.PI));
      
      // --- Rotation bras droit ---
      const rightUpperArmVec = new THREE.Vector3().subVectors( this.positionsPose3d.right_shoulder,this.positionsPose3d.right_elbow).normalize();
      const rightForearmVecArm = new THREE.Vector3().subVectors( this.positionsPose3d.right_wrist,this.positionsPose3d.right_elbow).normalize();
      const rightArmXAxis = new THREE.Vector3().crossVectors(rightUpperArmVec, rightForearmVecArm).normalize();
      const rightArmZAxis = new THREE.Vector3().crossVectors(rightArmXAxis, rightUpperArmVec).normalize();
      const rightArmMatrix = new THREE.Matrix4();
      rightArmMatrix.makeBasis(rightArmXAxis, rightUpperArmVec, rightArmZAxis);
      const rightUpperArmRotation = new THREE.Quaternion().setFromRotationMatrix(rightArmMatrix);

      // --- Rotation avant-bras gauche (méthode simplifiée) ---
      const leftForearmDirection = new THREE.Vector3().subVectors(this.positionsPose3d.left_wrist, this.positionsPose3d.left_elbow).normalize();
      const leftUpperArmDirection = new THREE.Vector3().subVectors(this.positionsPose3d.left_elbow, this.positionsPose3d.left_shoulder).normalize();
      const leftForearmSide = new THREE.Vector3().crossVectors(leftUpperArmDirection, leftForearmDirection).normalize();
      const leftForearmUp = new THREE.Vector3().crossVectors(leftForearmDirection, leftForearmSide).normalize();
      const leftForearmMatrix = new THREE.Matrix4();
      leftForearmMatrix.makeBasis(leftForearmSide, leftForearmUp, leftForearmDirection);
      const leftForearmRotation = new THREE.Quaternion().setFromRotationMatrix(leftForearmMatrix);
      leftForearmRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(-1, 0, 0), Math.PI/2));
      leftForearmRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI));
      
      // --- Rotation avant-bras droit (méthode simplifiée) ---
      const rightForearmDirection = new THREE.Vector3().subVectors(this.positionsPose3d.right_wrist, this.positionsPose3d.right_elbow).normalize();
      const rightUpperArmDirection = new THREE.Vector3().subVectors(this.positionsPose3d.right_elbow, this.positionsPose3d.right_shoulder).normalize();
      const rightForearmSide = new THREE.Vector3().crossVectors(rightUpperArmDirection, rightForearmDirection).normalize();
      const rightForearmUp = new THREE.Vector3().crossVectors(rightForearmDirection, rightForearmSide).normalize();
      const rightForearmMatrix = new THREE.Matrix4();
      rightForearmMatrix.makeBasis(rightForearmSide, rightForearmUp, rightForearmDirection);
      const rightForearmRotation = new THREE.Quaternion().setFromRotationMatrix(rightForearmMatrix);
      rightForearmRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(-1, 0, 0), Math.PI/2));
      rightForearmRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI));

      // --- Rotation main gauche  ---
      const leftHandY = new THREE.Vector3().subVectors(this.positionsPose3d.left_index, this.positionsPose3d.left_wrist).normalize();
      const lefthandZ = new THREE.Vector3().subVectors(this.positionsPose3d.left_thumb, this.positionsPose3d.left_wrist).normalize();
      const lefthandX = new THREE.Vector3().crossVectors(leftHandY, lefthandZ).normalize();
      const lefthandMatrix = new THREE.Matrix4();
      lefthandMatrix.makeBasis(lefthandX, leftHandY, lefthandZ);
      const leftHandRotation = new THREE.Quaternion().setFromRotationMatrix(lefthandMatrix);

      // --- Rotation main droite ---
      const rightHandY = new THREE.Vector3().subVectors(this.positionsPose3d.right_index, this.positionsPose3d.right_wrist).normalize();
      const righthandZ = new THREE.Vector3().subVectors(this.positionsPose3d.right_thumb, this.positionsPose3d.right_wrist).normalize();
      const righthandX = new THREE.Vector3().crossVectors(rightHandY, righthandZ).normalize();
      const righthandMatrix = new THREE.Matrix4();
      righthandMatrix.makeBasis(righthandX, rightHandY, righthandZ);
      const rightHandRotation = new THREE.Quaternion().setFromRotationMatrix(righthandMatrix);


      // --- Rotation upleg gauche (cuisse gauche) ---
      const leftUplegVec = new THREE.Vector3().subVectors( this.positionsPose3d.left_hip,this.positionsPose3d.left_knee).normalize();
      const leftLegVec = new THREE.Vector3().subVectors(this.positionsPose3d.left_knee,this.positionsPose3d.left_ankle ).normalize();
      const leftUplegXAxis = new THREE.Vector3().crossVectors(leftUplegVec, leftLegVec).normalize();
      const leftUplegZAxis = new THREE.Vector3().crossVectors(leftUplegXAxis, leftUplegVec).normalize();
      const leftUplegMatrix = new THREE.Matrix4();
      leftUplegMatrix.makeBasis(leftUplegXAxis, leftUplegVec, leftUplegZAxis);
      const leftUplegRotation = new THREE.Quaternion().setFromRotationMatrix(leftUplegMatrix);

      // --- Rotation upleg droit (cuisse droite) ---
      const rightUplegVec = new THREE.Vector3().subVectors( this.positionsPose3d.right_hip,this.positionsPose3d.right_knee).normalize();
      const rightLegVec = new THREE.Vector3().subVectors(this.positionsPose3d.right_knee,this.positionsPose3d.right_ankle ).normalize();
      const rightUplegXAxis = new THREE.Vector3().crossVectors(rightUplegVec, rightLegVec).normalize();
      const rightUplegZAxis = new THREE.Vector3().crossVectors(rightUplegXAxis, rightUplegVec).normalize();
      const rightUplegMatrix = new THREE.Matrix4();
      rightUplegMatrix.makeBasis(rightUplegXAxis, rightUplegVec, rightUplegZAxis);
      const rightUplegRotation = new THREE.Quaternion().setFromRotationMatrix(rightUplegMatrix);

      // --- Rotation leg gauche (tibia gauche) ---
      const leftLegVec2 = new THREE.Vector3().subVectors( this.positionsPose3d.left_knee,this.positionsPose3d.left_ankle).normalize();
      const leftFootVec = new THREE.Vector3().subVectors( this.positionsPose3d.left_foot_index,this.positionsPose3d.left_ankle).normalize();
      const leftLegXAxis = new THREE.Vector3().crossVectors(leftLegVec2, leftFootVec).normalize();
      const leftLegZAxis = new THREE.Vector3().crossVectors(leftLegXAxis, leftLegVec2).normalize();
      const leftLegMatrix = new THREE.Matrix4();
      leftLegMatrix.makeBasis(leftLegXAxis, leftLegVec2, leftLegZAxis);
      const leftLegRotation = new THREE.Quaternion().setFromRotationMatrix(leftLegMatrix);
    
      // --- Rotation leg droit (tibia droit) ---
      const rightLegVec2 = new THREE.Vector3().subVectors( this.positionsPose3d.right_knee,this.positionsPose3d.right_ankle).normalize();
      const rightFootVec = new THREE.Vector3().subVectors( this.positionsPose3d.right_foot_index,this.positionsPose3d.right_ankle).normalize();
      const rightLegXAxis = new THREE.Vector3().crossVectors(rightLegVec2, rightFootVec).normalize();
      const rightLegZAxis = new THREE.Vector3().crossVectors(rightLegXAxis, rightLegVec2).normalize();
      const rightLegMatrix = new THREE.Matrix4();
      rightLegMatrix.makeBasis(rightLegXAxis, rightLegVec2, rightLegZAxis);
      const rightLegRotation = new THREE.Quaternion().setFromRotationMatrix(rightLegMatrix);

      // --- Rotation pied gauche ---
      const leftFootY = new THREE.Vector3().subVectors(this.positionsPose3d.left_foot_index, this.positionsPose3d.left_ankle).normalize();
      const leftFootZ = new THREE.Vector3().subVectors(this.positionsPose3d.left_heel, this.positionsPose3d.left_ankle).normalize();
      const leftFootX = new THREE.Vector3().crossVectors(leftFootY, leftFootZ).normalize();
      const leftFootMatrix = new THREE.Matrix4();
      leftFootMatrix.makeBasis(leftFootX, leftFootY, leftFootZ);
      const leftFootRotation = new THREE.Quaternion().setFromRotationMatrix(leftFootMatrix);
      leftFootRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0,0), -Math.PI/2));
        
      // --- Rotation pied droit ---
      const rightFootY = new THREE.Vector3().subVectors(this.positionsPose3d.right_foot_index, this.positionsPose3d.right_ankle).normalize();
      const rightFootZ = new THREE.Vector3().subVectors(this.positionsPose3d.right_heel, this.positionsPose3d.right_ankle).normalize();
      const rightFootX = new THREE.Vector3().crossVectors(rightFootY, rightFootZ).normalize();
      const rightFootMatrix = new THREE.Matrix4();
      rightFootMatrix.makeBasis(rightFootX, rightFootY, rightFootZ);
      const rightFootRotation = new THREE.Quaternion().setFromRotationMatrix(rightFootMatrix);
      rightFootRotation.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0,0), -Math.PI/2));


      this.rotationsPose = {
        neutralRotation: neutralRotation,
        torsoRotation: torsoQuaternion,
        headRotation: headQuaternion5, // Utilise la nouvelle méthode optimisée
        headRotation2: headQuaternion2,
        headRotation3: headQuaternion3,
        headRotation4: headQuaternion4,
        headRotation5: headQuaternion5, // Nouvelle méthode optimisée (référence explicite)
        leftUpperArmRotation: leftUpperArmRotation,
        rightUpperArmRotation: rightUpperArmRotation,
        leftForearmRotation: leftForearmRotation,
        rightForearmRotation: rightForearmRotation,
        leftHandRotation: leftHandRotation,
        rightHandRotation: rightHandRotation,
        leftUplegRotation: leftUplegRotation,
        rightUplegRotation: rightUplegRotation,
        leftLegRotation: leftLegRotation,
        rightLegRotation: rightLegRotation,
        leftFootRotation: leftFootRotation,
        rightFootRotation: rightFootRotation,
      }




      // Stocker les quaternions et les vecteurs pour le debug      // Vecteurs directionnels pour le debug
      this.debugVectors = {
        torso: {
          up: torsoUpVector.clone(),
          right: torsoRightVector.clone(),
          forward: torsoForwardVector.clone()
        },
        head: {
          right: headRight5.clone(),
          up: headUp5Final.clone(),
          forward: headForward5.clone()
        }
      }

      this.scalesPose = {
        torsoScale: 0,
        neutralScale: 100,
        headScale: 0,
      }
      const torsoScale = this.positionsPose2d.center_shoulders.y - this.positionsPose2d.center_hips.y;
     // console.log("torsoScale", torsoScale);
      this.scalesPose.torsoScale = torsoScale*2.22 ;

      const headScale = this.positionsPose2d.center_eyes.y - this.positionsPose2d.center_mouth.y;
      this.scalesPose.headScale = headScale *17;

      // Console.log pour debug des données de visibilité
      // console.log('🔍 Données de visibilité Pose:', {
      //   visibilityPose: this.visibilityPose,
      //   exemples: {
      //     left_shoulder: this.visibilityPose.left_shoulder,
      //     right_shoulder: this.visibilityPose.right_shoulder,
      //     left_wrist: this.visibilityPose.left_wrist,
      //     right_wrist: this.visibilityPose.right_wrist,
      //     center_torso: this.visibilityPose.center_torso
      //   }
      // });

    }

    // Mettre à jour le debug visualizer avec les données calculées
    if (this.debugVisualizer) {
      this.updateDebugVisualizer();
    }    // Ajout du retour des paramètres demandés
    return {
      poseVisible: this.poseVisible,
      threeposeLandmarks2d: this.threeposeLandmarks2d,
      threeposeLandmarks3d: this.threeposeLandmarks3d,
      positionsPose2d: this.positionsPose2d,
      positionsPose3d: this.positionsPose3d,
      rotationsPose: this.rotationsPose,
      scalesPose: this.scalesPose,
      visibilityPose: this.visibilityPose,
      // Conserver pour compatibilité si nécessaire
      originalLandmarks: this.originalLandmarks,
      originalWorldLandmarks: this.originalWorldLandmarks,
    };

  }

  /**
   * Met à jour le debug visualizer avec les données de pose calculées
   */
  updateDebugVisualizer() {
    if (!this.debugVisualizer || !this.poseVisible) {
      return;
    }

    // Préparer les points calculés pour les sphères custom
    const customPoints = [];
    if (this.positionsPose2d) {
      const calculatedPointsArray = [
        this.positionsPose2d.center_hips,
        this.positionsPose2d.center_shoulders,
        this.positionsPose2d.center_ears,
        this.positionsPose2d.center_torso,
        this.positionsPose2d.left_torso,
        this.positionsPose2d.right_torso,
        this.positionsPose2d.center_eyes,
        this.positionsPose2d.center_mouth,
        this.positionsPose2d.left_arm,
        this.positionsPose2d.right_arm,
      ].filter(point => point);

      customPoints.push(...calculatedPointsArray);
    }    // Structure uniformisée and simplifiée
    const debugCoordsResults = {
      poseVisible: this.poseVisible,
      poseLandmarks2d: this.poseLandmarks2d,
      posePoints: this.threeposeLandmarks2d,
      customVisible: customPoints.length > 0,
      customPoints: customPoints,
      rotationsVisible: this.poseVisible,
      rotations: [
        {
          position: this.positionsPose2d.center_torso,
          vectors: this.debugVectors.torso,
          name: 'torso'
        },
        {
          position: this.positionsPose2d.center_eyes,
          vectors: this.debugVectors.head,
          name: 'head'
        }
      ]
    };

    // Mettre à jour le visualizer
    this.debugVisualizer.update(debugCoordsResults);
  }
}

const avg = (a, b) => new THREE.Vector3(
  (a.x + b.x) / 2,
  (a.y + b.y) / 2,
  (a.z + b.z) / 2
);

const avg3 = (a, b, c) => new THREE.Vector3(
  (a.x + b.x + c.x) / 3,
  (a.y + b.y + c.y) / 3,
  (a.z + b.z + c.z) / 3
);



